module.exports = __webpack_public_path__ + "static/media/coin_stack_level_1.64b2b769.svg";